import FavoriteCard from '../FavoriteCard';
import ProfileInfo from '../ProfileInfo';
import StaticsCard from '../StaticsCard';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import SkeletonProfileModalContent from './Skeleton';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { ErrorCard } from '@starsoft/common/components';
import { usePlayerStatistics } from '@/api/players';
import { useUserAccount } from '@/api/user';

export default function ProfileModalContent() {
  const { t } = useTranslation('common');
  const {
    player,
    isPending: isPendingPlayer,
    error: errorPlayer,
    refetch: refetchPlayer,
  } = usePlayerStatistics();
  const {
    error: errorUserAccount,
    refetch: refetchUserAccount,
    isLoading: isLoadingUserAccount,
  } = useUserAccount();
  const isPending: boolean = isLoadingUserAccount ?? isPendingPlayer;
  const error: AxiosError<GenericError> = errorPlayer ?? errorUserAccount;

  let formattedDate: string | undefined;

  if (player?.createdAt) {
    formattedDate = new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(new Date(player?.createdAt));
  }

  function refetch() {
    if (errorPlayer) {
      refetchPlayer();
    }

    if (errorUserAccount) {
      refetchUserAccount();
    }
  }

  if (isPending) {
    return <SkeletonProfileModalContent />;
  }

  if (error) {
    return (
      <div className={styles.container}>
        <ErrorCard error={error} refetch={refetch} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.container__main}>
        <ProfileInfo />
        <StaticsCard />
        <FavoriteCard />

        {formattedDate && (
          <div>
            <p className={styles['container__text-started-at']}>
              {t('modalProfile_joinedAt')} {formattedDate}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
